export default __webpack_public_path__ + "static/media/epl-banner-ms.0a4a540f.webp";